// Script for handing the minimum $5 check rule
document.addEventListener("DOMContentLoaded", function () {
    const cartForm = document.querySelector('form#cart');
    const checkoutBtn = document.querySelector('#checkout');
    const expressBtnsContainer = document.querySelector('.cart__dynamic-checkout-buttons');

    // Get subtotal in dollars
    function getSubtotal() {
      const subtotalEl = document.querySelector('.totals__total-value');
      if (!subtotalEl) return 0;
      const numberText = subtotalEl.innerText.replace(/[^0-9.]/g, "");
      const subtotal = parseFloat(numberText);
      return isNaN(subtotal) ? 0 : subtotal;
    }

    // Update checkout buttons and warning
    function enforceMinimum() {
      const subtotal = getSubtotal();
      let warning = document.getElementById("min-order-warning");

      if (!warning && checkoutBtn) {
        warning = document.createElement("p");
        warning.id = "min-order-warning";
        warning.style.color = "red";
        warning.style.fontWeight = "bold";
        warning.style.marginTop = "10px";
        checkoutBtn.parentNode.insertBefore(warning, checkoutBtn);
      }

      if (subtotal < 5) {
        if (checkoutBtn) {
          checkoutBtn.disabled = true;
          checkoutBtn.classList.add('disabled');
          checkoutBtn.innerText = "Minimum $5 order required";
        }
        if (expressBtnsContainer) {
          expressBtnsContainer.style.pointerEvents = 'none';
          expressBtnsContainer.style.opacity = 0.5;
        }
        if (warning) warning.innerText = "⚠️ You need at least $5 in your cart to checkout.";
      } else {
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
          checkoutBtn.classList.remove('disabled');
          checkoutBtn.innerText = "Check out";
        }
        if (expressBtnsContainer) {
          expressBtnsContainer.style.pointerEvents = 'auto';
          expressBtnsContainer.style.opacity = 1;
        }
        if (warning) warning.innerText = "";
      }
    }

    // Prevent checkout if subtotal < $5
    function preventCheckoutIfBelowMinimum(e) {
      if (getSubtotal() < 5) {
        e.preventDefault();
        alert("⚠️ Your cart must be at least $5 to checkout.");
        enforceMinimum();
        return false;
      }
    }

    // Disable checkout immediately when quantity/remove buttons are clicked
    function disableCheckoutTemporarily() {
      if (checkoutBtn) checkoutBtn.disabled = true;
      if (expressBtnsContainer) expressBtnsContainer.style.pointerEvents = 'none';
    }

    // Attach click guard to main and dynamic checkout buttons
    if (checkoutBtn) checkoutBtn.addEventListener('click', preventCheckoutIfBelowMinimum);
    if (expressBtnsContainer) {
      expressBtnsContainer.querySelectorAll('button').forEach(btn => btn.addEventListener('click', preventCheckoutIfBelowMinimum));
    }
    if (cartForm) cartForm.addEventListener('submit', preventCheckoutIfBelowMinimum);

    // Attach click listeners to quantity and remove buttons
    function attachQuantityRemoveListeners() {
      const quantityButtons = document.querySelectorAll('.quantity__button');
      quantityButtons.forEach(btn => btn.addEventListener('click', disableCheckoutTemporarily));

      const removeButtons = document.querySelectorAll('cart-remove-button a');
      removeButtons.forEach(btn => btn.addEventListener('click', disableCheckoutTemporarily));
    }
    attachQuantityRemoveListeners();

    // Re-attach listeners if new items are added via AJAX
    if (cartForm) {
      const observer = new MutationObserver(() => {
        enforceMinimum();
        attachQuantityRemoveListeners();
      });
      observer.observe(cartForm, { childList: true, subtree: true });
    }

    // Also observe totals to re-enable checkout
    const totalsEl = document.querySelector('.totals');
    if (totalsEl) {
      const totalsObserver = new MutationObserver(enforceMinimum);
      totalsObserver.observe(totalsEl, { childList: true, subtree: true });
    }

    // Initial enforcement
    enforceMinimum();
  });